import { ArrowRight } from "lucide-react";
import { useSite } from "../../lib/site";
import { href } from "../../lib/i18n";
import { SmartLink } from "./Common";
import { SiteIcon } from "./SiteIcon";

export const DEFAULT_BUTTONS = [
  { label: { tr: "Disiplinleri Keşfet", en: "Explore" }, kind: "section", value: "disiplinler", variant: "primary", icon: "arrow-right", icon_pos: "end" },
  { label: { tr: "Eserler & Yazılar", en: "Works & Writing" }, kind: "route", value: "news", variant: "secondary", icon: "book-open", icon_pos: "start" },
];

export const resolveLink = (b, lang) => {
  if (b.kind === "section") return `#${b.value}`;
  if (b.kind === "route") return href(lang, b.value || "home");
  if (b.kind === "page") return href(lang, "page", b.value);
  return b.value || "";
};

const VARIANT = {
  primary: "bg-s-primary hover:brightness-110 text-s-onprimary font-bold shadow-glow transition-[filter]",
  secondary: "border border-site-border bg-s-surface hover:bg-slate-800 text-white font-medium transition-colors",
  outline: "border border-s-primary text-s-primary hover:bg-s-primary hover:text-s-onprimary font-semibold transition-colors",
  ghost: "text-white hover:text-s-primary font-medium transition-colors px-2",
};

export function HeroButtons({ buttons }) {
  const { lang, t } = useSite();
  const list = (buttons || DEFAULT_BUTTONS).filter((b) => !b.hidden && t(b.label));
  if (!list.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-4 pt-4" data-testid="hero-buttons">
      {list.map((b, i) => {
        const to = resolveLink(b, lang);
        const icon = b.icon && <SiteIcon name={b.icon} size={15} className={b.icon_pos === "end" ? "group-hover:translate-x-1 transition-transform" : ""} />;
        const cls = `group px-8 py-4 rounded-xl text-sm tracking-wide flex items-center gap-3 ${VARIANT[b.variant] || VARIANT.primary}`;
        const pos = b.icon_pos || "start";
        const body = <>{pos === "start" && icon}{t(b.label)}{pos === "end" && (icon || <ArrowRight size={14} />)}</>;
        const testid = i === 0 ? "hero-cta-primary" : i === 1 ? "hero-cta-secondary" : `hero-cta-${i}`;
        return b.kind === "section"
          ? <a key={i} href={to} className={cls} data-testid={testid}>{body}</a>
          : <SmartLink key={i} to={to} newTab={b.new_tab} className={cls} data-testid={testid}>{body}</SmartLink>;
      })}
    </div>
  );
}
